import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

type Props = {
  selectedTemplate: string | undefined;
  handleReplaceTemplate: () => void;
};

const ReplaceBoardTemplateFooter: FC<Props> = ({
  selectedTemplate,
  handleReplaceTemplate,
}: Props) => {
  const { t } = useTranslate();

  return (
    <Modal.Footer>
      <button
        type="button"
        className="btn btn-lg btn-primary"
        onClick={handleReplaceTemplate}
        disabled={!selectedTemplate}
      >
        {t('Replace')}
      </button>
    </Modal.Footer>
  );
};

export default ReplaceBoardTemplateFooter;
